import { requestFavorites } from '../redux/favorites';
import type { ActionObs, Store, Obs } from '../types';
import { ACCOUNT_FETCH_SUCCEEDED, LOG_IN_SUCCEEDED } from '../redux/account';

export default function accountFavoritesEpic(
  action$: ActionObs,
  store: Store,
): Obs {
  return action$
    .ofType(ACCOUNT_FETCH_SUCCEEDED, LOG_IN_SUCCEEDED)
    .map(() => requestFavorites());
}
